import { createAsyncThunk } from "@reduxjs/toolkit";
import { BANNERIMAGES } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getBannerImagesListAPI: any = createAsyncThunk(
  "getBannerImagesList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(BANNERIMAGES, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: params,
      });
      return { bannerImages: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
